<template>
<div class="certificate-list">
<div class="container-fluid">
  <div class="table-responsive overflowXHidden">
    <table class="table table-striped width-94-Perc margin-0-auto">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Enabled Certification</th>
          <th class="text-align-center font-size-15px border-right"># of Course Completion Count</th>
          <th class="text-align-center font-size-15px border-right">Title</th>
          <th class="text-align-center font-size-15px border-right">Date</th>
          <th class="text-align-center font-size-15px border-right">Certificate Url</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(existingCertificateObj) in getExistingCertificateList" :key="existingCertificateObj.CertificateId" v-bind:existingCertificateObj="existingCertificateObj" > 
          <td class="border-right text-align-center col-lg-1">{{existingCertificateObj.EnableCertification ? 'Yes' : 'No'}}</td>
          <td class="border-right text-align-center col-lg-1">{{(existingCertificateObj.CompletionCriteriaForCertificate !== undefined && existingCertificateObj.CompletionCriteriaForCertificate !== 'undefined' && existingCertificateObj.CompletionCriteriaForCertificate !== null && existingCertificateObj.CompletionCriteriaForCertificate !== 'null' && existingCertificateObj.CompletionCriteriaForCertificate !== '') ? existingCertificateObj.CompletionCriteriaForCertificate : 0}}</td>
          <td class="border-right text-align-center col-lg-3">{{existingCertificateObj.CertificateTitle}}</td>
          <td class="border-right text-align-center col-lg-3">{{existingCertificateObj.CertificationDate}}</td>
          <td class="border-right text-align-center col-lg-2"><a :href=existingCertificateObj.CertificateFile target="_blank"><u>Preview</u></a></td>
          <td class="text-align-center col-lg-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'update', existingCertificateObj)"> Edit  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', existingCertificateObj)"> Delete</a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteTopicString" v-bind:postfixString="postDeleteTopicString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
  <update-certificate v-if="showUpdateCertificateOverlay" :selectedExistingCertificateObj="getSelectedExistingCertificateObj" :selectedGroupObj="selectedGroupObj" :groupCourseList="groupCourseList" @updatedValues="CloseCurrentOpenUpdatePopupOverlay" @showSpinner="emitShowSpinner"></update-certificate>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import UpdateCertificate from '@/components/group/UpdateCertificate'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { groupService } from '@/server-util/group-service'
import Loader from '@/components/dashboard/Loader'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['selectedGroupObj', 'groupCourseList', 'existingCertificateList'],
  data: function () {
    return {
      showUpdateCertificateOverlay: false,
      selectedExistingCertificateObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      prefixDeleteTopicString: '',
      postDeleteTopicString: '',
      showConfirmationBox: false
    }
  },
  name: 'certificate-list',
  methods: {
    emitShowSpinner (value) {
      this.$emit('showSpinner', value)
    },
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteSelectedCertificate()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete certificate overlay
      this.showConfirmationBox = value
    },
    CloseCurrentOpenUpdatePopupOverlay (value) {
      this.$emit('updatedValues', value)
      this.showUpdateCertificateOverlay = false
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    performClickOperation: function (event, selectedOperation, selectedObj) {
      this.selectedExistingCertificateObj = selectedObj
      switch (selectedOperation) {
        case 'update':
          this.showUpdateCertificateOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteTopicString = 'Are you sure you want delete '
          this.postDeleteTopicString = '\'' + this.selectedExistingCertificateObj.CertificateTitle + '\' certificate?'
          break
      }
    },
    deleteSelectedCertificate: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedExistingCertificateObj.CertificateId !== undefined &&
        this.selectedExistingCertificateObj.CertificateId !== null &&
        this.selectedExistingCertificateObj.CertificateId !== 'null'
      ) {
        // _this.showSpinner = true
        _this.$emit('showSpinner', true)
        groupService
          .deleteGroupCertificate(
            storeObj.state.access_token,
            this.selectedExistingCertificateObj.CertificateId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                var objToReturn = {
                  certificateObj: this.selectedExistingCertificateObj,
                  currentOperation: 'Delete_Certificate'
                }
                _this.$emit('updatedValues', objToReturn)
                _this.$emit('showSpinner', false)
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                _this.$emit('showSpinner', false)
              }
            },
            errorObj => {
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'CertificateId is NULL hence declined DELETE CERTIFICATE OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'update-certificate': UpdateCertificate,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getExistingCertificateList: {
      get: function () {
        return this.existingCertificateList
      }
    },
    getSelectedExistingCertificateObj: {
      get: function () {
        return this.selectedExistingCertificateObj
      }
    },
    getMasterTopicListFromState: {
      get: function () {
        return this.$store.state.existingCertificateList
      },
      set: function (newValue) {
        this.$store.state.existingCertificateList = newValue
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.certificate-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}

a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.overflowXHidden {
  overflow-x: hidden;
}
.width-94-Perc {
  width: 94%;
}
.margin-0-auto {
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/group/CertificateList.vue